import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { markNotificationRead, watchNotifications, type AppNotification } from "../lib/firebase";

export function NotificationBell({ userId }: { userId: string }) {
  const [items, setItems] = useState<AppNotification[]>([]);
  const [open, setOpen] = useState(false);
  const wrap = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();

  useEffect(() => watchNotifications(userId, setItems), [userId]);

  // Close the panel on any click outside it.
  useEffect(() => {
    if (!open) return;
    function onDown(e: MouseEvent) {
      if (wrap.current && !wrap.current.contains(e.target as Node)) setOpen(false);
    }
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open]);

  const unread = items.filter((n) => !n.readAt).length;

  function openNotification(n: AppNotification) {
    setOpen(false);
    if (!n.readAt) void markNotificationRead(userId, n.id);
    if (n.type === "certificate") return navigate("/admin/homework");
    // Hash scrolls the lesson page straight to that question.
    navigate(`/courses/${n.courseId}/lessons/${n.lessonId}#q-${n.questionId}`);
  }

  return (
    <div className="notif" ref={wrap}>
      <button
        type="button"
        className="notif__bell"
        onClick={() => setOpen((o) => !o)}
        aria-label={unread > 0 ? `การแจ้งเตือน (ยังไม่อ่าน ${unread})` : "การแจ้งเตือน"}
      >
        🔔
        {unread > 0 && <span className="notif__badge">{unread}</span>}
      </button>
      {open && (
        <div className="notif__panel">
          {items.length === 0 && <p className="notif__empty">ยังไม่มีการแจ้งเตือน</p>}
          {items.map((n) => (
            <button
              key={n.id}
              type="button"
              className={`notif__item${n.readAt ? "" : " notif__item--unread"}`}
              onClick={() => openNotification(n)}
            >
              <strong>
                {n.type === "certificate"
                  ? `🏆 ${n.authorName || "นักเรียน"} ขอใบเซอร์: รอดิวอนุมัติ`
                  : n.type === "question"
                  ? `💬 ${n.authorName || "นักเรียน"} ถามคำถามใหม่: กดเพื่อไปตอบ`
                  : "🎉 Dewviko AI (AI Coach) ตอบคำถามของคุณแล้ว: กดเพื่อดูคำตอบ"}
              </strong>
              <span className="notif__q">“{n.questionText}”</span>
              <span className="notif__date">{n.createdAt.toLocaleDateString("th-TH")}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
